import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import PrivacyPolicyText from "../../global-components/src/components/privacy-policy";

const PrivacyPolicy = () => {
    return (
        <>
            <Screen paddingTopTitle={true} title="Política de privacidade">
                <Helmet>
                    <title>Paçoca - Política de privacidade</title>
                    <meta name="description" content="Política de privacidade do Paçoca: dados coletados, anúncios, compartilhamentos, retenção e direitos." />
                    <meta name="robots" content="index,follow" />
                    <meta property="og:title" content="Paçoca - Política de privacidade" />
                    <meta property="og:description" content="Saiba como o Paçoca coleta, usa, compartilha e protege dados pessoais." />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="website" />
                </Helmet>
                <div className="padding-big-screen">
                    <PrivacyPolicyText system="Paçoca" />
                </div>
            </Screen>
        </>
    );
};

export default PrivacyPolicy;
